export default __webpack_public_path__ + "images/0x514910771af9ca656af840dff83e8264ecf986ca.png";